import { URL_TO_INTERNAL_SPORT } from "./unified-types";

export function resolveSlotSport(
  rawParam: string | null,
  defaultSport: string,
  available: readonly string[]
): string {
  if (!rawParam) return defaultSport;
  if (rawParam === "sup" && available.includes("sup") &&
      !available.includes("sup-touring")) {
    return "sup";
  }
  const internal = URL_TO_INTERNAL_SPORT[rawParam] ?? rawParam;
  if (internal === "swim" && available.includes("swimming")) {
    return "swimming";
  }
  return available.includes(internal) ? internal : defaultSport;
}
